import { render, staticRenderFns } from "./HierarchyView2.vue?vue&type=template&id=b6c6d87c&"
import script from "./HierarchyView2.vue?vue&type=script&lang=js&"
export * from "./HierarchyView2.vue?vue&type=script&lang=js&"
import style0 from "./HierarchyView2.vue?vue&type=style&index=0&id=b6c6d87c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports